/** VERSION: 0.0.1 Please do not delete this line. Thank you! **/
if (typeof lazySizes !== 'function') {
	/*! lazysizes - v4.1.8 */
	!function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P--, (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++, _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
	/*! ls.rias.min.ks - v4.1.8 */
	!function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
		// Placeholder  
		showPlaceholderProductList: true,
		placeholderProductPerRow: 3,
		placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
		enableOTP: true,
		separateRefineByFromFilter: true,
		filterTreeMobileStyle: 'style3', // 'style2', 'style3',
		equal_height: boostPFSThemeConfig.custom.equal_height,
		cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.equal_height_crop_image_position,
		defaultDisplay: boostPFSThemeConfig.custom.product_item_type
	},
	selector: {
		//otpButtons: '.boost-pfs-filter-product-item-image'
	}
};

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		firstVariant = {},
		boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
		boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
			// Displaying price base on the policy of Shopify, have to multiple by 100
			soldOut = !data.available; // Check a product is out of stock
			onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
			priceVaries = data.price_min != data.price_max; // Check a product has many prices
			// Convert images to array
			images = data.images_info;
			// Get First Variant (selected_or_first_available_variant)
			firstVariant = data['variants'][0];
			if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
				var paramVariant = data.variants.filter(function (e) {
					return e.id == Utils.getParam('variant');
				});
				if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
			} else {
				for (var i = 0; i < data['variants'].length; i++) {
					if (data['variants'][i].available) {
						firstVariant = data['variants'][i];
						break;
					}
				}
			}
			return data;
		}

		/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
		/************************** BUILD PRODUCT LIST **************************/
		// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data, index) {
		if (!data) data = this.data;
		if (!index) index = this.index;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		 console.log('DATA OBJECT:', data);
		 console.log('DATA KEYS:', Object.keys(data));
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add promotion cards
		if(boostPFSTemplate.custom_banners_product.trim().length > 10) {
			if(index == parseFloat(boostPFSThemeConfig.custom.banners_product)) {
				itemHtml = boostPFSTemplate.custom_banners_product + itemHtml;
			}
		}
		if(boostPFSTemplate.custom_banners_1.trim().length > 10) {
			if(index == parseFloat(boostPFSThemeConfig.custom.banners_1)) {
				itemHtml = boostPFSTemplate.custom_banners_1 + itemHtml;
			}
		}
		if(boostPFSTemplate.custom_banners_2.trim().length > 10) {
			if(index == parseFloat(boostPFSThemeConfig.custom.banners_2)) {
				itemHtml = boostPFSTemplate.custom_banners_2 + itemHtml;
			}
		}
		if(boostPFSTemplate.custom_banners_3.trim().length > 10) {
			if(index == parseFloat(boostPFSThemeConfig.custom.banners_3)) {
				itemHtml = boostPFSTemplate.custom_banners_3 + itemHtml;
			}
		}
		if(boostPFSTemplate.custom_banners_4.trim().length > 10) {
			if(index == parseFloat(boostPFSThemeConfig.custom.banners_4)) {
				itemHtml = boostPFSTemplate.custom_banners_4 + itemHtml;
			}
		}
		
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		// Add Grid Width class
		itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		// Add TAG Label
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

				// Build slider dots images (start from second image onwards)
		var itemDots = '';
		if (data.images_info && data.images_info.length > 1) {
			itemDots = '<div class="slider collection-product-slider medium-hide">';
			itemDots += '<ul class="pro-mob-images">';
			for (var i = 1; i < data.images_info.length; i++) { // start from index 1
				itemDots += '<a href="' + Utils.buildProductItemUrl(data) + '"><li data-img="' + data.images_info[i].src + '"><img src="' + data.images_info[i].src + '" alt="' + data.title + '"></li></a>';
			}
			itemDots += '</ul></div>';
		}
		itemHtml = itemHtml.replace(/{{itemDots}}/g, itemDots);


		// Add Price
		// itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

				// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

		// Build Custom Tag Badges
		var tagBadges = '';

		if (data.tags && data.tags.length > 0) {

			if (data.tags.includes('restock')) {
				tagBadges += '<span class="restock-badge" style="color: ' + boostPFSThemeConfig.custom.restocked_badge_color + ';">Restocked</span>';
			}

			if (data.tags.includes('coming-soon')) {
				tagBadges += '<span class="restock-badge" style="color: ' + boostPFSThemeConfig.custom.coming_soon_badge_color + ';">Coming Soon</span>';
			}

			if (data.tags.includes('new')) {
				tagBadges += '<span class="restock-badge new-badge-color" style="color: ' + boostPFSThemeConfig.custom.new_badge_color + ';">New</span>';
			}

			if (data.tags.includes('pre-order')) {
				tagBadges += '<span class="restock-badge preoder-badge-color" style="color: ' + boostPFSThemeConfig.custom.preorder_badge_color + ';">Pre-Order</span>';
			}

			if (data.tags.includes('online-exclusive')) {
				tagBadges += '<span class="restock-badge exclusive-badge-color" style="color: ' + boostPFSThemeConfig.custom.exclusive_badge_color + ';">Online Exclusive</span>';
			}
		}

		// Replace custom badge placeholder
		itemHtml = itemHtml.replace(/{{itemCustomBadges}}/g, tagBadges);

		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// itemActiveSwapClass
		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));
		// Add Color Swatches
		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
	};
	// Build Product List Item
	ProductListItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// For List View
		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		// Add TAG Label
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Description
		var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
		itemDescription = (itemDescription.split(" ")).length > 35 ? itemDescription.split(" ").splice(0, 35).join(" ") + '...' : itemDescription.split(" ").splice(0, 35).join(" ");
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

		// itemActiveSwapClass
		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

		// Add Color Swatches
		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);

		return itemHtml;
		// End For List View
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildGridWidthClass() {
		var gridWidthClass = '';
		// On PC
		switch (boostPFSThemeConfig.custom.products_per_row) {
			case 2:
				gridWidthClass = 'boost-pfs-filter-grid-width-2';
				break;
			case 3:
				gridWidthClass = 'boost-pfs-filter-grid-width-3';
				break;
			case 5:
				gridWidthClass = 'boost-pfs-filter-grid-width-5';
				break;
			case 6:
				gridWidthClass = 'boost-pfs-filter-grid-width-6';
				break;
			default:
				gridWidthClass = 'boost-pfs-filter-grid-width-4';
				break;
		}
		// On Mobile
		switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
			case 1:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
				break;
			case 3:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
				break;
			default:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
				break;
		}
		return gridWidthClass;
	}

	function buildImages(data) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingTop = 100;

		var dataSrcSet = '',
			dataWidths = '',
			dataSizes = 'auto',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			boostPFSThemeConfig.custom.active_image_swap == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			//dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			dataSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			dataWidths += rangeWidths[i];

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[2]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';
				dataWidths += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}

		if (images.length > 0) {
			aspectRatio = images[1]['width'] / images[1]['height'];
			paddingTop = 1 / aspectRatio * 100;
		}

		html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link small-hide" ';
		html += 'style="padding-top:' + paddingTop + '%;">';
		html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
			'data-srcset="' + dataSrcSet + '" ' +
			//'data-src="' + Utils.getFeaturedImage(images, rangeWidths[2] + 'x') + '" ' +
			'data-src="' + Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + '" ' +
			'data-widths="[' + dataWidths + ']" ' +
			'data-sizes="' + dataSizes + '" ' +
			'src="' + boostPFSImgDefaultSrc + '" ' +
			'alt="' + imgAlt + '" ';

		if (activeSwapImage) {
			html += 'data-img-flip-src="' + Utils.optimizeImage(images[2]['src'], rangeWidths[2] + 'x') + '" ' +
				'data-img-flip-srcset="' + flipImageSrcSet + '" ';
		}
		html += '/></a>';

		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor == true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		if (data.available) {
			if (boostPFSThemeConfig.custom.hasOwnProperty('show_price') &&
				boostPFSThemeConfig.custom.show_price) {
				html = '<p class="boost-pfs-filter-product-item-price">';
				if (onSale) {

					html += '<span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(data.price_min, undefined, true).replace(/,/g, ' ') + '</span>';
					html += '<s>' + Utils.formatMoney(data.compare_at_price_min, undefined, true).replace(/,/g, ' ') + '</s> ';
				} else {
					if (priceVaries) {
						html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' ' + '</span>';
					}
					html += '<span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(data.price_min, undefined, true).replace(/,/g, ' ') + '</span>';
				}
				html += '</p>';
			}
		} else {
			html += '<span class="boost-pfs-filter-product-item-regular-price product-sold-out">Out of stock</span>';
		}

		return html;
	}

	function buildLabels(data) {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_sold_out_label') &&
			boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
		}
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
		}
		// Build Labels
		return soldOutLabel + saleLabel;
	}

	// BUILD LABEL PRODUCT WITH TAGS
	function buildTagLabels(data, showall) {
		var label = '';
		if (data.tags) {

			for (var i = 0; i < data.tags.length; i++) {
				var tag = data.tags[i];
				var onSale = data.compare_at_price_min > data.price_min;
                 if (tag === 'new-1') {
					label = '<div class="grid-item__tag badge-new"><svg width="79" height="40" viewBox="0 0 79 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3.45312" y="0.25" width="76" height="30.5106" transform="rotate(6.5 3.45312 0.25)" fill="#36C2E1"></rect><path d="M23.0224 23.0598L23.5205 18.6881C23.5567 18.3702 23.7006 16.8245 23.7765 15.5932L23.8083 15.5968C24.0457 16.6223 24.4558 17.8285 24.7522 18.6191L26.4721 23.4529L30.351 23.8948L31.6189 12.7668L28.5666 12.419L28.0812 16.6795C28.0069 17.3313 27.8648 18.861 27.8071 19.9334L27.7753 19.9297C27.4779 18.8652 27.0432 17.5918 26.7277 16.6863L25.101 12.0242L21.238 11.584L19.9701 22.7121L23.0224 23.0598ZM40.2217 17.9017C39.5651 17.0217 38.4872 16.448 37.0246 16.2813C35.6575 16.1256 34.533 16.3839 33.6884 17.0124C32.7766 17.6654 32.2561 18.7011 32.1075 20.0046C31.9536 21.3559 32.2437 22.484 32.9694 23.3235C33.6386 24.0922 34.6885 24.6305 36.0874 24.7899C38.3925 25.0526 40.075 24.2781 40.7266 22.5165L37.7969 21.9411C37.5882 22.642 37.1437 23.0101 36.317 22.9159C35.3155 22.8018 34.941 22.1311 35.0483 21.0483L40.8984 21.7148C41.115 20.0969 40.9206 18.8348 40.2217 17.9017ZM36.8445 18.1449C37.3373 18.2011 37.6426 18.3486 37.8325 18.6601C37.9979 18.9044 38.0589 19.2173 38.0631 19.6043L35.2652 19.2855C35.351 18.9571 35.479 18.6818 35.6615 18.4932C35.9539 18.1884 36.3199 18.0852 36.8445 18.1449ZM46.189 25.6993L47.2634 22.4883C47.4345 21.9764 47.7253 20.9789 47.977 20.0414L48.0088 20.045C48.0291 20.9974 48.0853 21.7768 48.1555 22.5738L48.4782 25.9601L51.7848 26.3369L54.7979 18.5479L51.9364 18.2219L50.8699 21.7881C50.7111 22.3336 50.5415 22.9745 50.2951 23.8643L50.2633 23.8607C50.1935 22.9188 50.1742 22.2402 50.1314 21.7683L49.7903 17.9774L46.8334 17.6405L45.6397 21.1922C45.499 21.5787 45.2672 22.3414 45.0014 23.2612L44.9696 23.2576C44.9352 22.2874 44.9213 21.5612 44.8925 21.107L44.6555 17.3923L41.7464 17.0609L42.9142 25.3262L46.189 25.6993ZM57.9154 23.251L58.7139 19.4933L59.1233 15.9005L56.1664 15.5636L55.7571 19.1564L55.6739 22.9957L57.9154 23.251ZM57.8713 27.0303L58.2046 24.1053L55.2159 23.7648L54.8826 26.6898L57.8713 27.0303Z" fill="white"></path></svg></div>';
					break;
				} else if  (tag === 'new-2') {
					label = '<div class="grid-item__tag badge-new"><svg width="79" height="40" viewBox="0 0 79 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3.45312" y="0.25" width="76" height="30.5106" transform="rotate(6.5 3.45312 0.25)" fill="#36C2E1"/><path d="M23.0224 23.0598L23.5205 18.6881C23.5567 18.3702 23.7006 16.8245 23.7765 15.5932L23.8083 15.5968C24.0457 16.6223 24.4558 17.8285 24.7522 18.6191L26.4721 23.4529L30.351 23.8948L31.6189 12.7668L28.5666 12.419L28.0812 16.6795C28.0069 17.3313 27.8648 18.861 27.8071 19.9334L27.7753 19.9297C27.4779 18.8652 27.0432 17.5918 26.7277 16.6863L25.101 12.0242L21.238 11.584L19.9701 22.7121L23.0224 23.0598ZM40.2217 17.9017C39.5651 17.0217 38.4872 16.448 37.0246 16.2813C35.6575 16.1256 34.533 16.3839 33.6884 17.0124C32.7766 17.6654 32.2561 18.7011 32.1075 20.0046C31.9536 21.3559 32.2437 22.484 32.9694 23.3235C33.6386 24.0922 34.6885 24.6305 36.0874 24.7899C38.3925 25.0526 40.075 24.2781 40.7266 22.5165L37.7969 21.9411C37.5882 22.642 37.1437 23.0101 36.317 22.9159C35.3155 22.8018 34.941 22.1311 35.0483 21.0483L40.8984 21.7148C41.115 20.0969 40.9206 18.8348 40.2217 17.9017ZM36.8445 18.1449C37.3373 18.2011 37.6426 18.3486 37.8325 18.6601C37.9979 18.9044 38.0589 19.2173 38.0631 19.6043L35.2652 19.2855C35.351 18.9571 35.479 18.6818 35.6615 18.4932C35.9539 18.1884 36.3199 18.0852 36.8445 18.1449ZM46.189 25.6993L47.2634 22.4883C47.4345 21.9764 47.7253 20.9789 47.977 20.0414L48.0088 20.045C48.0291 20.9974 48.0853 21.7768 48.1555 22.5738L48.4782 25.9601L51.7848 26.3369L54.7979 18.5479L51.9364 18.2219L50.8699 21.7881C50.7111 22.3336 50.5415 22.9745 50.2951 23.8643L50.2633 23.8607C50.1935 22.9188 50.1742 22.2402 50.1314 21.7683L49.7903 17.9774L46.8334 17.6405L45.6397 21.1922C45.499 21.5787 45.2672 22.3414 45.0014 23.2612L44.9696 23.2576C44.9352 22.2874 44.9213 21.5612 44.8925 21.107L44.6555 17.3923L41.7464 17.0609L42.9142 25.3262L46.189 25.6993ZM57.9154 23.251L58.7139 19.4933L59.1233 15.9005L56.1664 15.5636L55.7571 19.1564L55.6739 22.9957L57.9154 23.251ZM57.8713 27.0303L58.2046 24.1053L55.2159 23.7648L54.8826 26.6898L57.8713 27.0303Z" fill="white"/></svg></div>';
					break;
				} else if  (tag === 'new-3') {
					label = '<div class="grid-item__tag badge-new"><svg width="90" height="57" viewBox="0 0 90 57" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40.9453 0H48.0547L77 48.1137L71.4141 54H19.6172L12 46.0663L40.9453 0Z" fill="#FE7250"/><path d="M31.0634 42.0827L30.5229 37.9932C30.4836 37.6958 30.2632 36.2572 30.0523 35.1199L30.0821 35.1161C30.5312 35.9955 31.1785 37.0006 31.6278 37.6531L34.2913 41.6635L37.9208 41.1922L36.545 30.7827L33.6889 31.1536L34.2157 35.1389C34.2963 35.7486 34.5147 37.1724 34.7059 38.161L34.6762 38.1648C34.1636 37.2633 33.4787 36.2027 32.9859 35.4499L30.4462 31.5747L26.8315 32.0441L28.2074 42.4535L31.0634 42.0827ZM47.7456 39.9164L47.4488 37.6709L42.4359 38.3219L42.1824 36.4036L46.6598 35.8222L46.3728 33.651L41.8954 34.2325L41.6536 32.4034L46.6665 31.7524L46.3697 29.5069L38.3074 30.5539L39.6833 40.9633L47.7456 39.9164ZM54.3007 39.0652L54.7315 34.4261C54.7971 33.4344 54.8389 32.4912 54.8728 31.4885L54.9174 31.4827C55.1919 32.4151 55.517 33.3863 55.8115 34.2405L57.4393 38.6576L60.8755 38.2114L61.9094 27.489L58.8153 27.8908L58.6669 32.7201C58.631 33.708 58.6569 34.476 58.6468 35.4303L58.6022 35.4361C58.3128 34.5056 58.0391 33.6941 57.7337 32.8716L55.9891 28.2578L52.9843 28.648L52.5591 33.5586C52.4758 34.4165 52.4688 35.2796 52.3993 36.2415L52.3546 36.2473C52.1028 35.3725 51.94 34.713 51.6161 33.6357L50.2026 29.0092L47.0789 29.4148L50.8645 39.5114L54.3007 39.0652Z" fill="white"/></svg></div>';
					break;
				} else if  (tag === 'preorder') {
					label = '<div class="grid-item__tag badge-new"><svg width="92" height="41" viewBox="0 0 92 41" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="10.0571" width="88.8421" height="30.5106" transform="rotate(-6.5 0 10.0571)" fill="#FE7250"/><path d="M15.2437 28.3946L14.8289 24.7541L16.4345 24.5712C18.835 24.2977 21.2642 23.57 20.8875 20.2634C20.5071 16.925 17.8865 16.821 15.5178 17.0909L10.7646 17.6324L12.0325 28.7604L15.2437 28.3946ZM14.2421 19.6034L15.5615 19.4531C16.6107 19.3335 17.4782 19.3152 17.6268 20.6188C17.7771 21.9383 16.9313 22.1473 15.8662 22.2687L14.5627 22.4172L14.2421 19.6034ZM27.2739 18.7145C25.944 18.9143 25.2162 19.5931 24.995 20.7616L24.8139 19.1719L21.8411 19.5106L22.7558 27.5386L25.8081 27.1909L25.4603 24.1386C25.2502 22.2946 26.0026 21.5486 27.4334 21.3856C27.6241 21.3639 27.8008 21.3598 27.9298 21.3612L27.6855 18.6515C27.5583 18.666 27.3675 18.6877 27.2739 18.7145ZM36.0078 18.911C35.1701 18.2013 33.9907 17.8848 32.5282 18.0514C31.161 18.2072 30.1235 18.7119 29.4419 19.5142C28.7004 20.3555 28.4261 21.4818 28.5747 22.7854C28.7286 24.1366 29.2651 25.1706 30.161 25.8253C30.986 26.4238 32.13 26.7121 33.529 26.5528C35.8341 26.2901 37.2992 25.157 37.5378 23.294L34.5538 23.3924C34.5081 24.1223 34.1578 24.5809 33.3311 24.6751C32.3296 24.7892 31.8139 24.2199 31.6748 23.1407L37.525 22.4742C37.372 20.849 36.8987 19.663 36.0078 18.911ZM32.7719 19.9077C33.2647 19.8516 33.5953 19.9267 33.8505 20.1874C34.0666 20.3883 34.1964 20.6794 34.2876 21.0555L31.4897 21.3743C31.4993 21.0351 31.5621 20.738 31.6975 20.5133C31.9138 20.1504 32.2473 19.9675 32.7719 19.9077ZM43.2644 25.4435C45.951 25.1374 47.589 23.26 47.2937 20.6687C47.0003 18.0934 45.0138 16.6288 42.2953 16.9386C39.5451 17.2519 37.9335 19.0781 38.2324 21.7011C38.5385 24.3877 40.4983 25.7587 43.2644 25.4435ZM43.0361 23.4405C42.6228 23.4876 42.2904 23.3966 42.0725 23.1799C41.7501 22.8946 41.5682 22.2873 41.4595 21.3334C41.3508 20.3796 41.3933 19.7628 41.6273 19.4141C41.805 19.1362 42.0943 18.9905 42.5236 18.9416C42.9369 18.8945 43.2498 18.9555 43.4891 19.2181C43.7796 19.5071 43.9598 20.0985 44.0666 21.0364C44.1735 21.9743 44.1328 22.607 43.9165 22.9698C43.7388 23.2477 43.4495 23.3934 43.0361 23.4405ZM53.4173 15.7358C52.0874 15.9356 51.3595 16.6144 51.1384 17.7829L50.9573 16.1932L47.9845 16.5319L48.8992 24.56L51.9514 24.2122L51.6037 21.16C51.3936 19.3159 52.146 18.5699 53.5767 18.4069C53.7675 18.3852 53.9442 18.3812 54.0731 18.3826L53.8288 15.6728C53.7016 15.6873 53.5109 15.709 53.4173 15.7358ZM60.2027 16.0738C59.6388 15.3651 58.8146 15.0564 57.7813 15.1742C55.667 15.4151 54.4423 17.2455 54.7321 19.789C55.0346 22.4438 56.5883 23.9255 58.7503 23.6791C59.7995 23.5596 60.5632 23.0539 60.8946 22.1466L61.0123 23.1799L64.0169 22.8375L62.749 11.7095L59.7444 12.0519L60.2027 16.0738ZM59.5218 21.5461C58.5044 21.662 58.1422 21.0269 57.9592 19.4213C57.8614 18.5629 57.8739 17.9656 58.1043 17.5851C58.2783 17.2754 58.5818 17.112 59.0428 17.0595C59.9966 16.9508 60.4315 17.6581 60.6018 19.1525C60.6996 20.0109 60.643 20.6454 60.3845 21.0613C60.2068 21.3392 59.9192 21.5008 59.5218 21.5461ZM72.149 14.7933C71.3113 14.0835 70.1319 13.767 68.6693 13.9336C67.3022 14.0894 66.2646 14.5941 65.5831 15.3964C64.8416 16.2378 64.5673 17.3641 64.7158 18.6676C64.8698 20.0189 65.4063 21.0528 66.3022 21.7076C67.1272 22.306 68.2712 22.5944 69.6702 22.435C71.9752 22.1724 73.4404 21.0392 73.679 19.1762L70.695 19.2747C70.6493 20.0045 70.299 20.4631 69.4723 20.5573C68.4708 20.6714 67.955 20.1021 67.816 19.023L73.6661 18.3564C73.5132 16.7313 73.0399 15.5452 72.149 14.7933ZM68.9131 15.79C69.4059 15.7338 69.7365 15.8089 69.9916 16.0697C70.2078 16.2705 70.3376 16.5617 70.4287 16.9378L67.6308 17.2566C67.6405 16.9173 67.7033 16.6203 67.8387 16.3955C68.055 16.0327 68.3884 15.8498 68.9131 15.79ZM79.7314 12.7377C78.4015 12.9375 77.6737 13.6163 77.4525 14.7848L77.2714 13.1951L74.2986 13.5338L75.2133 21.5619L78.2656 21.2141L77.9178 18.1619C77.7077 16.3178 78.4601 15.5718 79.8908 15.4088C80.0816 15.3871 80.2583 15.383 80.3873 15.3845L80.1429 12.6747C80.0158 12.6892 79.825 12.7109 79.7314 12.7377Z" fill="white"/></svg></div>';
					break;
				}
				// if (onSale) {
				// 	label = '<div class="grid-item__tag badge-new"><svg width="90" height="57" viewBox="0 0 90 57" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse rx="38.3382" ry="16.8377" transform="matrix(0.999498 -0.0316681 0.0524527 0.998623 41.5918 26.0853)" fill="#E9407D"/><path d="M26.2457 32.0263C28.6145 31.9513 31.0497 31.1389 30.9136 28.5475C30.7854 26.1059 28.7891 25.5539 26.2136 25.1254C24.9259 24.9111 24.1518 24.7556 24.1196 24.1414C24.0857 23.4973 24.6231 23.1502 25.5377 23.1212C26.4972 23.0908 27.1789 23.4893 27.29 24.7462L30.3595 24.2888C29.9891 21.8099 27.9202 21.0202 25.4315 21.099C23.0477 21.1745 20.9415 22.2466 21.0571 24.4485C21.1736 26.6655 22.8739 27.3018 25.3752 27.7477C26.7245 27.99 27.7479 28.0326 27.788 28.7966C27.8313 29.6204 27.1274 29.9428 26.1829 29.9727C25.1334 30.006 24.2087 29.5552 24.1505 28.1616L21.002 28.5464C21.2423 31.1196 23.5021 32.1133 26.2457 32.0263ZM42.3426 31.2913L38.0737 20.9235L34.3556 21.0413L31.1582 31.6456L34.3666 31.544L34.8601 29.5028L38.4133 29.3902L39.1342 31.3929L42.3426 31.2913ZM35.8368 25.5107C35.9971 24.8454 36.1297 24.226 36.2948 23.3656L36.3098 23.3651C36.514 24.1088 36.8122 24.9246 37.0062 25.4736L37.5875 27.1057L35.4286 27.1741L35.8368 25.5107ZM51.2053 31.0105L51.0731 28.4939L46.1556 28.6497L45.737 20.6807L42.6785 20.7776L43.2293 31.2632L51.2053 31.0105ZM60.3741 30.72L60.2553 28.4581L55.2028 28.6182L55.1013 26.6858L59.6141 26.5428L59.4992 24.3559L54.9865 24.4988L54.8897 22.6564L59.9422 22.4963L59.8234 20.2344L51.6974 20.4919L52.2482 30.9774L60.3741 30.72Z" fill="white"/></svg></div>';
				// } else if (tag === 'new-1') {
				// 	label = '<div class="grid-item__tag badge-new"><svg width="79" height="40" viewBox="0 0 79 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3.45312" y="0.25" width="76" height="30.5106" transform="rotate(6.5 3.45312 0.25)" fill="#36C2E1"></rect><path d="M23.0224 23.0598L23.5205 18.6881C23.5567 18.3702 23.7006 16.8245 23.7765 15.5932L23.8083 15.5968C24.0457 16.6223 24.4558 17.8285 24.7522 18.6191L26.4721 23.4529L30.351 23.8948L31.6189 12.7668L28.5666 12.419L28.0812 16.6795C28.0069 17.3313 27.8648 18.861 27.8071 19.9334L27.7753 19.9297C27.4779 18.8652 27.0432 17.5918 26.7277 16.6863L25.101 12.0242L21.238 11.584L19.9701 22.7121L23.0224 23.0598ZM40.2217 17.9017C39.5651 17.0217 38.4872 16.448 37.0246 16.2813C35.6575 16.1256 34.533 16.3839 33.6884 17.0124C32.7766 17.6654 32.2561 18.7011 32.1075 20.0046C31.9536 21.3559 32.2437 22.484 32.9694 23.3235C33.6386 24.0922 34.6885 24.6305 36.0874 24.7899C38.3925 25.0526 40.075 24.2781 40.7266 22.5165L37.7969 21.9411C37.5882 22.642 37.1437 23.0101 36.317 22.9159C35.3155 22.8018 34.941 22.1311 35.0483 21.0483L40.8984 21.7148C41.115 20.0969 40.9206 18.8348 40.2217 17.9017ZM36.8445 18.1449C37.3373 18.2011 37.6426 18.3486 37.8325 18.6601C37.9979 18.9044 38.0589 19.2173 38.0631 19.6043L35.2652 19.2855C35.351 18.9571 35.479 18.6818 35.6615 18.4932C35.9539 18.1884 36.3199 18.0852 36.8445 18.1449ZM46.189 25.6993L47.2634 22.4883C47.4345 21.9764 47.7253 20.9789 47.977 20.0414L48.0088 20.045C48.0291 20.9974 48.0853 21.7768 48.1555 22.5738L48.4782 25.9601L51.7848 26.3369L54.7979 18.5479L51.9364 18.2219L50.8699 21.7881C50.7111 22.3336 50.5415 22.9745 50.2951 23.8643L50.2633 23.8607C50.1935 22.9188 50.1742 22.2402 50.1314 21.7683L49.7903 17.9774L46.8334 17.6405L45.6397 21.1922C45.499 21.5787 45.2672 22.3414 45.0014 23.2612L44.9696 23.2576C44.9352 22.2874 44.9213 21.5612 44.8925 21.107L44.6555 17.3923L41.7464 17.0609L42.9142 25.3262L46.189 25.6993ZM57.9154 23.251L58.7139 19.4933L59.1233 15.9005L56.1664 15.5636L55.7571 19.1564L55.6739 22.9957L57.9154 23.251ZM57.8713 27.0303L58.2046 24.1053L55.2159 23.7648L54.8826 26.6898L57.8713 27.0303Z" fill="white"></path></svg></div>';
				// 	break;
				// } else if  (tag === 'new-2') {
				// 	label = '<div class="grid-item__tag badge-new"><svg width="79" height="40" viewBox="0 0 79 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3.45312" y="0.25" width="76" height="30.5106" transform="rotate(6.5 3.45312 0.25)" fill="#36C2E1"/><path d="M23.0224 23.0598L23.5205 18.6881C23.5567 18.3702 23.7006 16.8245 23.7765 15.5932L23.8083 15.5968C24.0457 16.6223 24.4558 17.8285 24.7522 18.6191L26.4721 23.4529L30.351 23.8948L31.6189 12.7668L28.5666 12.419L28.0812 16.6795C28.0069 17.3313 27.8648 18.861 27.8071 19.9334L27.7753 19.9297C27.4779 18.8652 27.0432 17.5918 26.7277 16.6863L25.101 12.0242L21.238 11.584L19.9701 22.7121L23.0224 23.0598ZM40.2217 17.9017C39.5651 17.0217 38.4872 16.448 37.0246 16.2813C35.6575 16.1256 34.533 16.3839 33.6884 17.0124C32.7766 17.6654 32.2561 18.7011 32.1075 20.0046C31.9536 21.3559 32.2437 22.484 32.9694 23.3235C33.6386 24.0922 34.6885 24.6305 36.0874 24.7899C38.3925 25.0526 40.075 24.2781 40.7266 22.5165L37.7969 21.9411C37.5882 22.642 37.1437 23.0101 36.317 22.9159C35.3155 22.8018 34.941 22.1311 35.0483 21.0483L40.8984 21.7148C41.115 20.0969 40.9206 18.8348 40.2217 17.9017ZM36.8445 18.1449C37.3373 18.2011 37.6426 18.3486 37.8325 18.6601C37.9979 18.9044 38.0589 19.2173 38.0631 19.6043L35.2652 19.2855C35.351 18.9571 35.479 18.6818 35.6615 18.4932C35.9539 18.1884 36.3199 18.0852 36.8445 18.1449ZM46.189 25.6993L47.2634 22.4883C47.4345 21.9764 47.7253 20.9789 47.977 20.0414L48.0088 20.045C48.0291 20.9974 48.0853 21.7768 48.1555 22.5738L48.4782 25.9601L51.7848 26.3369L54.7979 18.5479L51.9364 18.2219L50.8699 21.7881C50.7111 22.3336 50.5415 22.9745 50.2951 23.8643L50.2633 23.8607C50.1935 22.9188 50.1742 22.2402 50.1314 21.7683L49.7903 17.9774L46.8334 17.6405L45.6397 21.1922C45.499 21.5787 45.2672 22.3414 45.0014 23.2612L44.9696 23.2576C44.9352 22.2874 44.9213 21.5612 44.8925 21.107L44.6555 17.3923L41.7464 17.0609L42.9142 25.3262L46.189 25.6993ZM57.9154 23.251L58.7139 19.4933L59.1233 15.9005L56.1664 15.5636L55.7571 19.1564L55.6739 22.9957L57.9154 23.251ZM57.8713 27.0303L58.2046 24.1053L55.2159 23.7648L54.8826 26.6898L57.8713 27.0303Z" fill="white"/></svg></div>';
				// 	break;
				// } else if  (tag === 'new-3') {
				// 	label = '<div class="grid-item__tag badge-new"><svg width="90" height="57" viewBox="0 0 90 57" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40.9453 0H48.0547L77 48.1137L71.4141 54H19.6172L12 46.0663L40.9453 0Z" fill="#FE7250"/><path d="M31.0634 42.0827L30.5229 37.9932C30.4836 37.6958 30.2632 36.2572 30.0523 35.1199L30.0821 35.1161C30.5312 35.9955 31.1785 37.0006 31.6278 37.6531L34.2913 41.6635L37.9208 41.1922L36.545 30.7827L33.6889 31.1536L34.2157 35.1389C34.2963 35.7486 34.5147 37.1724 34.7059 38.161L34.6762 38.1648C34.1636 37.2633 33.4787 36.2027 32.9859 35.4499L30.4462 31.5747L26.8315 32.0441L28.2074 42.4535L31.0634 42.0827ZM47.7456 39.9164L47.4488 37.6709L42.4359 38.3219L42.1824 36.4036L46.6598 35.8222L46.3728 33.651L41.8954 34.2325L41.6536 32.4034L46.6665 31.7524L46.3697 29.5069L38.3074 30.5539L39.6833 40.9633L47.7456 39.9164ZM54.3007 39.0652L54.7315 34.4261C54.7971 33.4344 54.8389 32.4912 54.8728 31.4885L54.9174 31.4827C55.1919 32.4151 55.517 33.3863 55.8115 34.2405L57.4393 38.6576L60.8755 38.2114L61.9094 27.489L58.8153 27.8908L58.6669 32.7201C58.631 33.708 58.6569 34.476 58.6468 35.4303L58.6022 35.4361C58.3128 34.5056 58.0391 33.6941 57.7337 32.8716L55.9891 28.2578L52.9843 28.648L52.5591 33.5586C52.4758 34.4165 52.4688 35.2796 52.3993 36.2415L52.3546 36.2473C52.1028 35.3725 51.94 34.713 51.6161 33.6357L50.2026 29.0092L47.0789 29.4148L50.8645 39.5114L54.3007 39.0652Z" fill="white"/></svg></div>';
				// 	break;
				// } else if  (tag === 'preorder') {
				// 	label = '<div class="grid-item__tag badge-new"><svg width="92" height="41" viewBox="0 0 92 41" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="10.0571" width="88.8421" height="30.5106" transform="rotate(-6.5 0 10.0571)" fill="#FE7250"/><path d="M15.2437 28.3946L14.8289 24.7541L16.4345 24.5712C18.835 24.2977 21.2642 23.57 20.8875 20.2634C20.5071 16.925 17.8865 16.821 15.5178 17.0909L10.7646 17.6324L12.0325 28.7604L15.2437 28.3946ZM14.2421 19.6034L15.5615 19.4531C16.6107 19.3335 17.4782 19.3152 17.6268 20.6188C17.7771 21.9383 16.9313 22.1473 15.8662 22.2687L14.5627 22.4172L14.2421 19.6034ZM27.2739 18.7145C25.944 18.9143 25.2162 19.5931 24.995 20.7616L24.8139 19.1719L21.8411 19.5106L22.7558 27.5386L25.8081 27.1909L25.4603 24.1386C25.2502 22.2946 26.0026 21.5486 27.4334 21.3856C27.6241 21.3639 27.8008 21.3598 27.9298 21.3612L27.6855 18.6515C27.5583 18.666 27.3675 18.6877 27.2739 18.7145ZM36.0078 18.911C35.1701 18.2013 33.9907 17.8848 32.5282 18.0514C31.161 18.2072 30.1235 18.7119 29.4419 19.5142C28.7004 20.3555 28.4261 21.4818 28.5747 22.7854C28.7286 24.1366 29.2651 25.1706 30.161 25.8253C30.986 26.4238 32.13 26.7121 33.529 26.5528C35.8341 26.2901 37.2992 25.157 37.5378 23.294L34.5538 23.3924C34.5081 24.1223 34.1578 24.5809 33.3311 24.6751C32.3296 24.7892 31.8139 24.2199 31.6748 23.1407L37.525 22.4742C37.372 20.849 36.8987 19.663 36.0078 18.911ZM32.7719 19.9077C33.2647 19.8516 33.5953 19.9267 33.8505 20.1874C34.0666 20.3883 34.1964 20.6794 34.2876 21.0555L31.4897 21.3743C31.4993 21.0351 31.5621 20.738 31.6975 20.5133C31.9138 20.1504 32.2473 19.9675 32.7719 19.9077ZM43.2644 25.4435C45.951 25.1374 47.589 23.26 47.2937 20.6687C47.0003 18.0934 45.0138 16.6288 42.2953 16.9386C39.5451 17.2519 37.9335 19.0781 38.2324 21.7011C38.5385 24.3877 40.4983 25.7587 43.2644 25.4435ZM43.0361 23.4405C42.6228 23.4876 42.2904 23.3966 42.0725 23.1799C41.7501 22.8946 41.5682 22.2873 41.4595 21.3334C41.3508 20.3796 41.3933 19.7628 41.6273 19.4141C41.805 19.1362 42.0943 18.9905 42.5236 18.9416C42.9369 18.8945 43.2498 18.9555 43.4891 19.2181C43.7796 19.5071 43.9598 20.0985 44.0666 21.0364C44.1735 21.9743 44.1328 22.607 43.9165 22.9698C43.7388 23.2477 43.4495 23.3934 43.0361 23.4405ZM53.4173 15.7358C52.0874 15.9356 51.3595 16.6144 51.1384 17.7829L50.9573 16.1932L47.9845 16.5319L48.8992 24.56L51.9514 24.2122L51.6037 21.16C51.3936 19.3159 52.146 18.5699 53.5767 18.4069C53.7675 18.3852 53.9442 18.3812 54.0731 18.3826L53.8288 15.6728C53.7016 15.6873 53.5109 15.709 53.4173 15.7358ZM60.2027 16.0738C59.6388 15.3651 58.8146 15.0564 57.7813 15.1742C55.667 15.4151 54.4423 17.2455 54.7321 19.789C55.0346 22.4438 56.5883 23.9255 58.7503 23.6791C59.7995 23.5596 60.5632 23.0539 60.8946 22.1466L61.0123 23.1799L64.0169 22.8375L62.749 11.7095L59.7444 12.0519L60.2027 16.0738ZM59.5218 21.5461C58.5044 21.662 58.1422 21.0269 57.9592 19.4213C57.8614 18.5629 57.8739 17.9656 58.1043 17.5851C58.2783 17.2754 58.5818 17.112 59.0428 17.0595C59.9966 16.9508 60.4315 17.6581 60.6018 19.1525C60.6996 20.0109 60.643 20.6454 60.3845 21.0613C60.2068 21.3392 59.9192 21.5008 59.5218 21.5461ZM72.149 14.7933C71.3113 14.0835 70.1319 13.767 68.6693 13.9336C67.3022 14.0894 66.2646 14.5941 65.5831 15.3964C64.8416 16.2378 64.5673 17.3641 64.7158 18.6676C64.8698 20.0189 65.4063 21.0528 66.3022 21.7076C67.1272 22.306 68.2712 22.5944 69.6702 22.435C71.9752 22.1724 73.4404 21.0392 73.679 19.1762L70.695 19.2747C70.6493 20.0045 70.299 20.4631 69.4723 20.5573C68.4708 20.6714 67.955 20.1021 67.816 19.023L73.6661 18.3564C73.5132 16.7313 73.0399 15.5452 72.149 14.7933ZM68.9131 15.79C69.4059 15.7338 69.7365 15.8089 69.9916 16.0697C70.2078 16.2705 70.3376 16.5617 70.4287 16.9378L67.6308 17.2566C67.6405 16.9173 67.7033 16.6203 67.8387 16.3955C68.055 16.0327 68.3884 15.8498 68.9131 15.79ZM79.7314 12.7377C78.4015 12.9375 77.6737 13.6163 77.4525 14.7848L77.2714 13.1951L74.2986 13.5338L75.2133 21.5619L78.2656 21.2141L77.9178 18.1619C77.7077 16.3178 78.4601 15.5718 79.8908 15.4088C80.0816 15.3871 80.2583 15.383 80.3873 15.3845L80.1429 12.6747C80.0158 12.6892 79.825 12.7109 79.7314 12.7377Z" fill="white"/></svg></div>';
				// 	break;
				// }


			}
		}

		return label;

		

		
		if (boostPFSThemeConfig.custom.show_lable_by_tag) {
			if (showall) {
				var tagLabel = '';
				if (data.tags) {

					for (var i = 0; i < data.tags.length; i++) {
						var tag = data.tags[i];

						if (tag.indexOf("pfs:label") !== -1) {
							var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
							tagLabel += preTagLabel;
						}
					}
				}
			} else {
				var tagLabel = '';
				if (data.tags) {
					
					for (var i = data.tags.length - 1; i >= 0; i--) {
						tag = data.tags[i];
						console.log("tag2", tag)

						if (tag.indexOf("pfs:label") !== -1) {
							var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
							tagLabel += preTagLabel;
							break;
						}
					}
				}
			}
			return tagLabel;
		} else {
			return "";
		}
	}

	// Build Color Swatches
	function buildColorSwatches(data) {
		var colorSwatchesHtml = '',
			filterSwatchTitle = 'Color',
			optionName = 'color',
			swatchArr = [],
			countSwatch = 0,
			swatchValues = [],
			swatchLimit = 4;

		var dataImgSize = '360',
			bgSize = '50x',
			//dataImgSrc = Utils.getFeaturedImage(data.images_info, dataImgSize + 'x'),
			dataImgSrc = Utils.optimizeImage(images[1]['src'], dataImgSize + 'x'),
			swatchName = '#ffffff',
			bgImageSrc = '',
			viewMoreLabel = 'More ' + filterSwatchTitle;

		if (boostPFSThemeConfig.custom.hasOwnProperty('display_item_swatch') && boostPFSThemeConfig.custom.display_item_swatch == true) {
			if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0) {
				swatchArr = data.options_with_values.filter(function (option) {
					return option.name == optionName;
				});
				if (swatchArr.length > 0) {
					countSwatch = swatchArr[0].values.length;

					if (swatchLimit > countSwatch) {
						swatchLimit = countSwatch;
					}
					swatchValues = swatchArr[0].values;

					colorSwatchesHtml += '<ul class="boost-pfs-filter-item-swatch">';

					for (var sIndex = 0; sIndex < swatchLimit; sIndex++) {
						swatchName = swatchValues[sIndex].title;
						sImageIndex = swatchValues[sIndex].image || '';
						if (sImageIndex != '') {
							dataImgSrc = Utils.optimizeImage(data.images[sImageIndex], dataImgSize + 'x') + ' ' + dataImgSize + 'w';
						}


						if (boostPFSThemeConfig.custom.hasOwnProperty('swatch_color_display_type')) {
							switch (boostPFSThemeConfig.custom.swatch_color_display_type) {
								case 'swatch_color_display_type_image_color':
									bgImageSrc = boostPFSAppConfig.general.file_url.replace(/\?/, Utils.slugify(filterSwatchTitle).replace(/\-/g, '_') + '-' + Utils.slugify(swatchName) + '.png?v=');
									break;
								case 'swatch_color_display_type_image_product':
									//bgImageSrc = Utils.getFeaturedImage(data.images_info, bgSize);
									bgImageSrc = Utils.optimizeImage(data.images[1], bgSize);
									if (sImageIndex != '') {
										bgImageSrc = Utils.optimizeImage(data.images[sImageIndex], bgSize);
									}
									break;
								default:
									bgImageSrc = '';
							}
						}

						colorSwatchesHtml += '<li>';
						colorSwatchesHtml += '<div class="boost-pfs-product-item-tooltip">' + swatchName + '</div>';
						colorSwatchesHtml += '<span tabindex="0" aria-label="' + swatchName + '" ' +
							'style="background-color: ' + swatchName + '; ';
						if (bgImageSrc != '') {
							colorSwatchesHtml += 'background-image: url(' + bgImageSrc + ');" ';
						} else {
							colorSwatchesHtml += '" ';
						}
						if (dataImgSrc != '') {
							colorSwatchesHtml += 'data-img="' + dataImgSrc + '" ';
						}

						colorSwatchesHtml += '></span>';
						colorSwatchesHtml += '</li>';
					}

					if (countSwatch > swatchLimit) {
						colorSwatchesHtml += '<li class="boost-pfs-filter-item-swatch-more">';
						colorSwatchesHtml += '<a href="{{itemUrl}}" title="' + viewMoreLabel + '">+' + (countSwatch - swatchLimit) + '</a>';
						colorSwatchesHtml += '</li>';
					}

					colorSwatchesHtml += '</ul>';
				}
			}
		}
		return colorSwatchesHtml;
	}

	// Build Color Swatches
	function eventColorSwatches(event) {
		jQ('.boost-pfs-filter-item-swatch li span').each(function () {
			var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
			if (event == 'hover') {
				jQ(this).hover(function () {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				});
			}
			if (event == 'click') {
				jQ(this).click(function () {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				});
			}
			jQ(this).focus(function () {
				if (jQ('body').hasClass('boost-pfs-ada')) {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				}
			});
		});
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}

	function buildActiveSwapClass(data) {
		if (!Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			boostPFSThemeConfig.custom.active_image_swap == true) {
			return 'has-bc-swap-image';
		}
		return '';
	}



	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					activeClass = '';
					if (paramSort == k) {
						activeClass = 'boost-pfs-filter-sort-item-active';
					}
					sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		var _this = this;
		jQ('.boost-pfs-filter-filter-dropdown a').click(function (e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		jQ(".boost-pfs-filter-custom-sorting > button").click(function () {
			if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
				jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
			}
		});

		jQ(Selector.filterTreeMobileButton).click(function () {
			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
		});
	};
	// For Toolbar - Build Display type
	ProductDisplayType.prototype.compileTemplate = function () {
		var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
		if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
			itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
			itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';

		} else {
			itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
			itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';

		}


		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Build Show Limit
	ProductLimit.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k in sortingArr) {
					showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};
	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function (colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbItemsHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				var colInfo = colData.collection;
				if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
					breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
				} else {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
				}
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
			}
		}
		return breadcrumbItemsHtml
	};

	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;

		// Intergrate Review Shopify
		if (window.SPR &&
			typeof window.SPR.initDomEls == 'function' &&
			typeof window.SPR.loadBadges == 'function' &&
			boostPFSThemeConfig.custom.show_product_review) {
			window.SPR.initDomEls();
			window.SPR.loadBadges();
		}
	};

	// Build additional elements
	Filter.prototype.afterRender = function (data) {
		if (!data) data = this.data;

		var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);

		jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

		// Prevent double tap on iOS
		var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		if (isiOS) {
			Utils.isMobile() && jQ(".boost-pfs-filter-product-item").find("a").on("touchstart", function () {
				isScrolling = !1
			}).on("touchmove", function () {
				isScrolling = !0
			}).on("touchend", function () {
				isScrolling || (window.location = jQ(this).attr("href"))
			});
		}

		// Build Image Swap. Put this function here to impprove the pagespeed.
		swapImage(data);

		// Build Equal Height
		if (Globals.queryParams.display !== 'list') {
			equalHeight(data);
		};

		jQ(window).resize(function () {
			if (Globals.queryParams.display !== 'list') {
				equalHeight(data);
			}
		});

		// Build Event Color Swatch
		if (boostPFSThemeConfig.custom.swatch_color_event_change_image != 'none') {
			eventColorSwatches(boostPFSThemeConfig.custom.swatch_color_event_change_image);
		}

		if (typeof boostRemoveImageLoadingAnimation == 'function') {
			boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'));
		}

		 initCollectionSliders();
	};


	// Add the slider initialization function 
// function initCollectionSliders() {
//     jQuery('.pro-mob-images').each(function () {
//         var $slider = jQuery(this);
//         if (!$slider.hasClass('slick-initialized')) {
//             $slider.slick({
//                 slidesToShow: 1,      // show 1 image per slide
//                 slidesToScroll: 1,    // scroll 1 image at a time
//                 arrows: false,
//                 dots: true,           // generate proper <ul class="slick-dots">
//                 infinite: false,
//                 focusOnSelect: true
//             });
//         }
//     });

//     // Update main product image on click
//     jQuery('.pro-mob-images li').off('click').on('click', function () {
//         var newImg = jQuery(this).attr('data-img');
//         var parent = jQuery(this).closest('.boost-pfs-filter-product-item');
//         parent.find('.boost-pfs-filter-product-item-image-link img').attr('src', newImg);
//     });
// }
function initCollectionSliders() {
    jQuery('.pro-mob-images').each(function () {
        var $slider = jQuery(this);
        if (!$slider.hasClass('slick-initialized')) {
            $slider.slick({
                slidesToShow: 1,      
                slidesToScroll: 1,    
                arrows: false,
                dots: true,           
                infinite: true,      
                focusOnSelect: true
            });
        }
    });

    // Update main product image on click
    jQuery('.pro-mob-images li').off('click').on('click', function () {
        var newImg = jQuery(this).attr('data-img');
        var parent = jQuery(this).closest('.boost-pfs-filter-product-item');
        parent.find('.boost-pfs-filter-product-item-image-link img').attr('src', newImg);
    });
}





	ProductListPlaceholder.prototype.render = function () {
		// Set limit number for product skeleton
		var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
		// Build placeholder items
		var placeholderItem = this.compileTemplate();
		this.$element = [];
		for (var i = 0; i < placeholderLimit; i++) {
			this.$element.push(jQ(placeholderItem));
		}
		// Show placeholder before send filter request OR hide it after get filter data
		if (!this.isFetchedProductData) {
			this.setShow();
		} else {
			this.setHide();
		}
	}

	ProductListPlaceholder.prototype.compileTemplateExtra = function () {
		var display = Globals.queryParams.display
		switch (display) {
			case 'list':
				//Todo: Build placeholder for List mode
				var template = boostPFSTemplate.productListPlaceholderHtml;
				var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
				var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
				/**
				 * Set product class for product skeleton (to set column, style, etc.)
				 * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
				 */
				break;
		}
		return template
			.replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
			.replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
			.replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
			.replace(/{{paddingTop}}/g, imgRatio * 100)
	}

	/* Prevent conflict with theme vendor js */
	Array.prototype.insert = function (a, b) { }

	/* Math qual Height */
	function equalHeight(data) {
		var equal_i = -1;
		var equal_els = [];
		var equal_element = null;

		// Equal Height Title
		jQ('.boost-pfs-filter-product-item').each(function (i, element) {

			var offsetTop = jQ(element).offset().top;
			if (!equal_element || equal_element.offset().top !== offsetTop) {
				equal_element = jQ(element);
				equal_i++;
			}

			if (!equal_els[equal_i]) {
				equal_els[equal_i] = [];
			}
			equal_els[equal_i].push(element);
		});

		for (var i = 0; i < equal_els.length; i++) {
			var max = 0;
			var maxRatio = 0;
			var iLength = equal_els[i].length;

			for (var j = 0; j < equal_els[i].length; j++) {
				var item = equal_els[i][j];
				var height = jQ(item).find('.boost-pfs-filter-product-bottom-inner').height();
				max = Math.max(max, height);

			}

			jQ(equal_els[i]).find('.boost-pfs-filter-product-bottom-inner').css({ 'min-height': max });

		}

		var equal_height = boostPFSFilterConfig.general.equal_height;

		if (equal_height != 'false') {
			var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

			var widthImage = jQ('.boost-pfs-filter-product-item').width();
			var indexData = 0;

			// For Ratio
			if (equal_height != 'false' && equal_height != 'auto') {
				var heightImage = 0;
				var widthImage = jQ('.boost-pfs-filter-product-item').width();
				if (equal_height != 'false' && equal_height != 'auto') {
					var ratioWidthHeight = boostPFSThemeConfig.custom.equal_height;
				} else {
					var ratioWidthHeight = '';
				}

				var ratioWidthHeightOther = boostPFSThemeConfig.custom.ratio_width_height_other;
				if (ratioWidthHeightOther == '' && ratioWidthHeight == '') {
					return null;
				} else {
					if (ratioWidthHeightOther == '') {
						ratioWidthHeight = ratioWidthHeight.split(':');
						ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
						heightImage = widthImage * ratioWidthHeight;
					} else if (ratioWidthHeightOther != '') {
						ratioWidthHeightOther = ratioWidthHeightOther.split(':');
						ratioWidthHeightOther = parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
						heightImage = widthImage * ratioWidthHeightOther;
					}
				}
				jQ('.boost-pfs-filter-product-item-image-link').css({ 'padding-top': heightImage + 'px' }).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);;

			}
		}
	}

	// Swap Image
	function swapImage(data) {
		if (!Utils.isMobile()) {
			if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
				boostPFSThemeConfig.custom.active_image_swap == true) {
				var dataSrcSetFlipImg = '',
					dataSrcFlipImg = '',
					flipImageAlt = '',
					dataSizes = 'auto',
					dataWidths = '',
					html = '';

				jQ(".boost-pfs-filter-product-item").each(function () {
					var productItemSelector = jQ(this);
					var imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image');

					if (typeof imgSelector.data('img-flip-src') != 'undefined' &&
						imgSelector.data('img-flip-src') != '') {
						dataSrcFlipImg = imgSelector.data('img-flip-src');
						dataSrcSetFlipImg = imgSelector.data('img-flip-srcset');
						flipImageAlt = imgSelector.attr('alt');
						dataWidths = imgSelector.data('widths');
						html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
							'data-srcset="' + dataSrcSetFlipImg + '" ' +
							'data-src="' + dataSrcFlipImg + '" ' +
							'data-widths="[' + dataWidths + ']" ' +
							'data-sizes="' + dataSizes + '" ' +
							'src="' + boostPFSImgDefaultSrc + '" ' +
							'alt="' + flipImageAlt + '" />';

						productItemSelector.find('.boost-pfs-filter-product-item-image-link').prepend(html);
					}

				});
			}
		}
	}

	// Build Placeholder for the first load
	function boostRemoveImageLoadingAnimation($selector) {
		if ($selector.length) {
			$selector.removeAttr('data-boost-image-loading-animation');
		}
	}

	/*Boost 100922*/
	FilterOptionItemBox.prototype.compileTemplate = function () {
		var regularSizes = ["XS", "S", "M", "L", "XL"];
		var newClass = Class.button;

		if (this.parent.filterOptionId == "pf_opt_size") {
			if (regularSizes.includes(this.value)) {
				newClass = Class.button + " boost-regular-size";
			} else {
				newClass = Class.button + " boost-double-size";
			}
		}

		return this.getTemplate()
			.replace(/{{class.filterOptionItem}}/g, Class.filterOptionItem)
			.replace(/{{class.filterOptionLabel}}/g, Class.filterOptionLabel)
			.replace(/{{disabled}}/g, this.isDisabled() ? 'disabled' : '')
			.replace(/{{class.button}}/g, newClass)
			.replace(/{{label}}/g, this.label)
			.replace(/{{countLabel}}/g, this.countLabel);
	}
	/*Boost 100922*/

      FilterApi.beforeCall = function(eventType, eventInfo) {
        if (Shopify && Globals) {
              Globals.queryParams.currency = Shopify.currency.active;
              Globals.queryParams.currency_rate = Shopify.currency.rate;
              Globals.queryParams.country = Shopify.country;
              Globals.queryParams.return_all_currency_fields = false;
        }
      }


	ProductPaginationLoadMore.prototype.compileTotalTemplate = function() {
		/**
		 * If enable the Load previous feature and the event type is page:
		 * => Get the next loading page is from session storage OR get the next loading page from query param
		 */
		if (!Globals.queryParams.page || isNaN(Globals.queryParams.page)) {
			Globals.queryParams.page = 1;
		}
		if (!Globals.queryParams.limit || isNaN(Globals.queryParams.limit)) {
			Globals.queryParams.limit = 20;
		}
		if (Utils.isLoadPreviousPagePaginationType() && this.parent.eventType == 'page') {
			this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage));
		} else {
			this.nextPage = Globals.queryParams.page;
		}
		// Set from index
		var fromProduct = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		var numberOfShowingProducts = jQ(Selector.products + ' > *:not(script):not(style)').length;
		if (numberOfShowingProducts) {
			// fromProduct -= numberOfShowingProducts - Globals.queryParams.limit;
		}
		this.fromProduct = fromProduct;

		// Set to index
		var product_index = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		var toProduct = product_index + this.data.products.length - 1;
		this.toProduct = toProduct;

		// console.log("fromProduct" , fromProduct, Labels)


		return this.getTemplate('total')
			.replace(/{{progressLable}}/g, Labels.loadMoreTotal)
			.replace(/{{ from }}/g, this.fromProduct)
			.replace(/{{ to }}/g, this.toProduct)
			.replace(/{{ total }}/g, this.totalProduct)
			.replace(/{{class.productLoadMore}}/g, Class.productLoadMore)
	}
})();